export default __webpack_public_path__ + "static/media/2211.0beb8838.png";